type Props = {
  activeEntitlements: number
  activeDevices: number
  adoption: number
  webhookHealthy: boolean
}

export function Summary({
  activeEntitlements,
  activeDevices,
  adoption,
  webhookHealthy,
}: Props) {
  const values = [
    ['Active entitlements', activeEntitlements.toLocaleString()],
    ['Active devices', activeDevices.toLocaleString()],
    ['30-day update reach', `${adoption}%`],
  ]

  return (
    <section className="summary" aria-label="Operational summary">
      {values.map(([label, value]) => (
        <div className="summary-item" key={label}>
          <span className="square accent" />
          <div>
            <span>{label}</span>
            <strong>{value}</strong>
          </div>
        </div>
      ))}
      <div className="summary-item">
        <span className="square accent" />
        <div>
          <span>Webhook health</span>
          <strong className="health-value">
            <i className={`square ${webhookHealthy ? 'success' : 'danger'}`} />
            {webhookHealthy ? 'Healthy' : 'Degraded'}
          </strong>
        </div>
      </div>
    </section>
  )
}
